import { render, staticRenderFns } from "./ModalCancelOrRejectTender.vue?vue&type=template&id=4aa17cb8"
import script from "./ModalCancelOrRejectTender.vue?vue&type=script&lang=js"
export * from "./ModalCancelOrRejectTender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports